import React from 'react';
import { View, Text } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';
import moment from 'moment';

import DataState from 'app/src/components/DataState';
import Reports from 'app/src/components/Reports';
import { useParams } from 'app/src/utils/routing';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   TitleContainer,
   PageTitle,
} from 'app/src/elements';

import { getStatus, getStatusType } from './elements';
import { SALE } from './queries';
import SaleProcess from './Process';
import BidFunctionsLegend from './Process/BidFunctionsLegend';

const SaleDetails = styled(View)`
  display: flex;
  justify-content: flex-end;
  text-align: end;
`;

const DetailsText = styled(Text)`
  text-align: end;
`;

const PageTitleStatusContainer = styled(View)`
  display: flex;
  flex-direction: row;
`;

export const StatusContainer = styled(View)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 40px;
  width: fit-content;
  padding: 20px;
  margin-left: 40px;
  margin-top: -5px;
`;

const StatusText = styled(Text)`
  color: #fff;
  font-weight: bold;
`;

const Sale = () => {
  let { id, tableType } = useParams();

  const { loading, error, data, refetch } = useQuery(
    SALE, { variables: { id } }
  );

  if (loading || !data) {
    return <DataState.Loading />;
  }

  const { sale } = data;

  if (!tableType) {
    const tableTypeStatus = getStatus(sale?.status, true);

    if ('post' === tableTypeStatus) {
      return <Reports saleId={sale.id} />;
    } else {
      tableType = tableTypeStatus;
    }
  }

  const buttonStyle = { backgroundColor: getStatusType(sale.status) };

  return (
    <MainContainer>
      <ContentContainer>
        <TitleContainer id="titlecontainer">
          <PageTitleStatusContainer>
            <PageTitle>{sale?.name}</PageTitle>
            <StatusContainer style={buttonStyle}>
              <StatusText>{sale?.status}</StatusText>
            </StatusContainer>
          </PageTitleStatusContainer>
          <SaleDetails>
            <DetailsText>
              Pre-Bid: <b>{moment(sale?.preBidOpenAt)?.format('MM-DD-YY \@ hh:mmA')}</b>
            </DetailsText>
            <DetailsText>
              Starts: <b>{moment(sale?.startAt)?.format('MM-DD-YY \@ hh:mmA')}</b>
            </DetailsText>
            <DetailsText>
              Ends: <b>{moment(sale?.endAt)?.format('MM-DD-YY \@ hh:mmA')}</b>
            </DetailsText>
          </SaleDetails>
        </TitleContainer>
        <TableContainer>
          {'pre' !== tableType && <BidFunctionsLegend />}
          <SaleProcess saleId={id} tableType={tableType} />
        </TableContainer>
      </ContentContainer>
    </MainContainer>
  );
};

export default Sale;
